/* eslint-disable max-len */
import { css } from '@emotion/react';

export const customizedFundListStyles = css`
    color: var(--default-text-color);

    .table {
        width: var(--tableComponent-tableWidth);

        th {
            border-style: var(--tableComponent-thBorderStyle);
            border-color: var(--tableComponent-thBorderColor);
            border-width: var(--tableComponent-thBorderWidth);
            font-family: var(--tableComponent-thFontFamily);
            color: var(--tableComponent-thTextColor);
            font-weight: var(--tableComponent-thFontWeight);
            font-size: var(--tableComponent-thFontSize);
            line-height: var(--tableComponent-thLineHeight);
            padding: var(--tableComponent-thPadding);
        }

        td {
            border-style: var(--tableComponent-tdBorderStyle);
            border-color: var(--tableComponent-tdBorderColor);
            border-width: var(--tableComponent-tdBorderWidth);
            font-family: var(--tableComponent-tdFontFamily);
            color: var(--tableComponent-tdTextColor);
            font-weight: var(--tableComponent-tdFontWeight);
            font-size: var(--tableComponent-tdFontSize);
            line-height: var(--tableComponent-tdLineHeight);
            padding: var(--tableComponent-tdPadding);
        }

        tbody {
            tr:nth-of-type(odd) {
                background-color: var(--tableComponent-alternatedRowsBGColor);
            }

            tr.row--group {
                background-color: var(--tableComponent-rowGroupBackgroundColor);
            }
        }

        tr:last-child {
            td {
                border: none;
            }
        }

        th {
            button.selected {
                background-color: var(--primary-contrastText);
                border-radius: 6px;
            }
        }
    }

    .notToggable {
        cursor: default;
    }

    .row-group-toggle {
        i {
            padding-right: 5px;
        }
    }

    .row-group-count {
        padding: 3px;
        border: 1px solid var(--default-text-color);
        border-radius: 50%;
    }

    .sort-button {
        .sort-icon {
            color: var(--default-text-color);
        }

        .sort-image {
            width: 1rem;
            height: 1rem;
        }
    }

    .pagination-component,
    .pagination-component-left,
    .pagination-component-center,
    .pagination-component-right {
        display: flex;
        justify-content: space-between;
        gap: 20px;
        flex-wrap: wrap;
        color: var(--color-text-primary);
        margin: 0px 5px;
        align-items: center;
    }

    .page-size-select {
        display: flex;
        align-items: center;
        flex-direction: row;
    }

    .page-size-text {
        margin-right: 10px;
    }

    .pagination-container {
        display: flex;
        list-style-type: none;

        .pagination-item {
            padding: 0 10px;
            height: 26px;
            text-align: center;
            margin: auto 4px;
            color: var(--color-text-primary);
            display: flex;
            box-sizing: border-box;
            align-items: center;
            line-height: 1.43;
            font-size: var(--body-small-fontSize);
            min-width: 26px;

            &.dots:hover {
                background-color: transparent;
                cursor: default;
            }
            &:hover {
                background-color: var(--color-text-lighter);
                cursor: pointer;
            }

            &.selected {
                background-color: var(--primary-contrastText);
            }

            &.disabled {
                pointer-events: none;
                opacity: 0.5;

                &:hover {
                    background-color: transparent;
                    cursor: default;
                }
            }
        }

        &.circle-buttons {
            .pagination-item {
                border-radius: 13px;
            }
        }
    }

    .arrow {
        &::before {
            position: relative;
            content: '';
            display: inline-block;
            width: 1em;
            height: 1em;
            border-right: 0.12em solid var(--color-text-primary);
            border-top: 0.12em solid var(--color-text-primary);
        }

        &.left {
            transform: rotate(-135deg);
        }

        &.right {
            transform: rotate(45deg);
        }
    }

    .table-controls-container {
        display: flex;
        justify-content: space-between;

        > div {
            width: 50%;
        }
    }

    .right-component {
        display: flex;
        gap: 10px;
        justify-content: flex-end;
    }

    .watchlist-button {
        display: flex;
        gap: 10px;
        height: 40px;
        border: 1px solid var(--color-text-primary);
        padding: 6px;
        border-radius: 24px;

        &.selected {
            background-color: var(--primary-contrastText);
        }

        .watchlist-count {
            width: 25px;
            height: 25px;
            border-radius: 50%;
            background-color: var(--color-text-lighter);
        }
    }

    .tabs-arrow-container {
        display: none;
    }

    .show-all-funds-button {
        display: flex;
        margin: auto 0;
        position: absolute;
        right: 0;
        top: 24em;
        width: 10em !important;
        cursor: pointer;

        &.disabled {
            pointer-events: none;
            opacity: 0.5;
            color: var(--brand-granite);
        }

        .arrow {
            font-size: 10px;
            margin-bottom: 2px;
        }
    }

    .download-button {
        display: flex;
        gap: 10px;
        height: 40px;
        border: 1px solid var(--color-text-primary);
        padding: 6px;
        border-radius: 24px;
        background-color: var(--color-text-lighter);
    }

    // Tabs
    .tabs-wrapper {
        display: flex;
        align-items: center;
        background-color: var(--color-white);

        .tab {
            cursor: pointer;
            padding: 0.5rem 1rem;
            color: var(--color-text-primary);

            &:hover {
                background-color: var(--color-primary);
                color: var(--color-text-primary-lightest);
            }
        }

        .tab-selected {
            background-color: var(--color-primary);
            color: var(--color-text-lighter);
        }
    }

    .tabs-wrapper-sticky {
        position: sticky;
        position: -webkit-sticky;
        z-index: 150;
        top: 0;
    }

    @media screen and (min-width: 1025px) and (min-width: 1281px) {
        .search-input-box {
            width: fit-content;
        }

        .filter {
            margin: 0 1rem;
        }
    }

    @media only screen and (min-width: 768px) and (max-width: 991px) {
        .filters-container {
            display: flex;
            flex-wrap: wrap;
            margin-left: 1rem;
            justify-content: space-between;
        }

        .text-filter,
        .date-range-picker-filter {
            flex: 1;
            flex-basis: calc(100% - 1rem);
            width: calc(100% - 1rem);
        }

        .dropdown-filter {
            flex-basis: calc(50% - 1rem);
            margin: 0.5rem 1rem 0 0;

            .dropdown-label {
                margin-top: 0.5rem;
            }
        }

        .dropdown-filter:nth-of-type(odd) {
            margin: 0.5rem 1rem 0 0;
        }

        .filter-dropdown {
            .dropdown-toggle {
                width: 100%;
            }
        }

        .search-input-box {
            width: calc(100% - 1rem);

            .filter-search-input {
                width: 100%;
            }
        }

        .date-filter-container {
            margin-top: 1rem;
        }

        .start-date-container,
        .end-date-container {
            width: calc(50% - 1rem);
        }

        .start-date-container {
            margin: 0.5rem 1rem 0 0;
        }

        .end-date-container {
            width: calc(50% - 1rem);
            margin: 0.5rem 1rem 0 0;
        }

        .custom-date-picker-input {
            width: 100%;
        }
    }

    @media only screen and (max-width: 767px) {
        .filters-container {
            display: flex;
            flex-direction: column;
            margin-left: 1rem;
        }

        .filter {
            margin-bottom: 0.5rem;
            flex: 1;
            flex-basis: calc(100% - 2rem);
            width: calc(100% - 2rem);
        }

        .search-input-box {
            width: 100%;

            .filter-search-input {
                width: 100%;
            }
        }

        .filter-dropdown {
            margin-top: 0.5rem;

            .dropdown-toggle {
                width: 100%;
            }
        }

        .date-filter-container {
            display: flex;
            flex-wrap: wrap;
        }

        .start-date-container,
        .end-date-container {
            flex: 1 0 100%;

            .custom-date-picker-input {
                width: 100%;
            }
        }
    }
    .card {
        border-style: var(--tableComponent-thBorderStyle);
        border-color: var(--tableComponent-thBorderColor);
        border-width: var(--tableComponent-thBorderWidth);
        line-height: var(--tableComponent-tdLineHeight);
        padding: var(--tableComponent-tdPadding);
        border-radius: 4px;
        .card-row {
            display: flex;
            justify-content: space-between;
            border-style: var(--tableComponent-thBorderStyle);
            border-color: var(--tableComponent-thBorderColor);
            border-width: var(--tableComponent-thBorderWidth);
            &:last-child {
                border: none;
            }
            p {
                margin: 0;
            }
            .left {
                font-family: var(--tableComponent-thFontFamily);
                color: var(--tableComponent-thTextColor);
                font-weight: var(--tableComponent-thFontWeight);
                font-size: var(--tableComponent-thFontSize);
                line-height: var(--tableComponent-thLineHeight);
                padding: var(--tableComponent-thPadding);

                button {
                    font-family: var(--tableComponent-thFontFamily);
                    color: var(--tableComponent-thTextColor);
                    font-weight: var(--tableComponent-thFontWeight);
                    font-size: var(--tableComponent-thFontSize);
                    line-height: var(--tableComponent-thLineHeight);
                    margin-left: -6px;
                }

                button.selected {
                    background-color: var(--primary-contrastText);
                    border-radius: 6px;
                }
            }
            .right {
                font-family: var(--tableComponent-tdFontFamily);
                color: var(--tableComponent-tdTextColor);
                font-weight: var(--tableComponent-tdFontWeight);
                font-size: var(--tableComponent-tdFontSize);
                line-height: var(--tableComponent-tdLineHeight);
                padding: var(--tableComponent-tdPadding);
            }
        }
    }
    .custom-calendar-day-width {
        width: 3.7rem;
    }
    @media (max-width: 768px) {
        .pagination-component {
            flex-direction: column;
            align-items: center;
            gap: 5px;
            margin-top: 5px;
        }
        .pagination-component-right ul {
            padding: 0;
        }
        .table-controls-container {
            flex-direction: column;
            > div {
                width: 100%;
                padding-right: 10px;
            }
        }
    }

    @media (max-width: 1023px) {
        .show-all-funds-button {
            top: 35em;
        }
    }

    @media (max-width: 768px) {
        .pagination-container {
            .pagination-item {
                height: 23px;
                min-width: 22px;
                padding: 0 7px;
            }
        }
        .table-controls-container {
            .right-component {
                button {
                    font-size: 10px;
                    height: 33px;
                    .watchlist-count {
                        width: 20px;
                        height: 20px;
                    }
                }
            }
        }

        .show-all-funds-button {
            top: 52.5em;
            margin-left: 1em;
        }
    }

    @media (max-width: 600px) {
        .show-all-funds-button {
            position: initial;
        }

        .tabs-wrapper {
            overflow-x: scroll;
            height: 5em;
            padding-right: 4em !important;
            scroll-behavior: smooth;
            -ms-overflow-style: none;
            scrollbar-width: none;

            .tab {
                text-wrap: nowrap;
            }

            .tabs-arrow-container {
                display: block;
                position: absolute;
                background-color: white;
                height: 5em;
                width: 3em;
                margin-bottom: 5px;
                z-index: 10;

                &.right {
                    right: 4px;
                    padding: 2em 0.25em;
                }

                &.left {
                    left: 4px;
                    padding: 0.85em 0.25em;
                    display: none;

                    &.show {
                        display: block;
                    }
                }
            }
        }

        .tabs-wrapper::-webkit-scrollbar {
            display: none;
        }
    }

    .column-group-toggle {
        width: 100%;
    }

    .column-groups {
        text-align: center;
    }

    .download-booklet {
        .download-booklet-button {
            display: flex;
            gap: 10px;
            height: 40px;
            border: 1px solid var(--default-border-color);
            padding: 6px;
            border-radius: 24px;
            background-color: var(--color-text-lighter);
        }

        .booklet-messages-container {
            margin-top: 15px;
        }

        .booklet-success,
        .booklet-download-info {
            border: 1px solid var(--default-border-color);
            border-radius: 0.3rem;
            padding: 5px;
        }

        .booklet-success a {
            color: var(--default-text-color);
            text-decoration: underline;
        }

        .download-booklet-text {
            margin-left: 0.3rem;
        }

        .download-booklet-message-icon {
            i {
                color: blue;
            }
        }

        .download-booklet-error-icon {
            i {
                color: red;
            }
        }
    }
`;
